import $ from 'jquery'


/**
 * 数组元素合并
 * @param objArr
 * @param o
 */
export const objsExtend = (objArr, o) => {
  for (let i = 0; i < objArr.length; i++) {
    extend(objArr[i], o)
  }
};

/**
 * 元素合并
 * 封装jq extend方法，使用深度合并
 * @param target
 * @param os
 */
export const extend = (target, ...os) => {
  $.extend(true, target, ...os);
  return target;
};

/**
 * 克隆对象，封装jq extend方法，使用深拷贝，防止vue双向绑定污染
 * @param obj
 */
export const clone = (obj) => {
  return extend({}, obj);
};

export const isEmpty = function (o) {
  switch (typeof o) {
    case 'undefined':
      return true;
    case 'string':
      if (o.length === 0 || o.split('').filter(s => /\s/g.test(s)).length === o.length) {
        return true;
      }
      break;
    case 'boolean':
      return !o;
    case 'number':
      if (0 === o || isNaN(o))
        return true;
      break;
    case 'object':
      if (null === o || o.length === 0)
        return true;
      for (let key in o) {
        return false;
      }
      return true;
  }
  return false;
};




// WEBPACK FOOTER //
// ./src/js/utils/objUtils.js